// extracted by mini-css-extract-plugin
module.exports = {"badgeFilter":"NFilterBadge_badgeFilter__1eHML","badgeIcon":"NFilterBadge_badgeIcon__2CXmV"};